<app-select-language [supportedLanguages]="supportedLanguages"
  [selectedLanguageId]="selectedLanguageId"
  [dialogMessage]="'SETTINGS.GENERAL.LANGUAGE' | translate"
  (selectedLanguageChange)="onChangeLanguage($event)">
</app-select-language>